export const GridConstants = Object.freeze({
  GRID_ITEM_IMAGE_SIZE: 500,
  NUM_BUFFER_ROWS: 3,
  NUM_PLACEHOLDERS: 5,
  THROTTLE_RATE: 200,
  TIME_TO_WAIT_FOR_SCROLL_TO_END_MS: 500,
} as const);

export const ResponsiveGridConstants = Object.freeze({
  MEDIUM_BREAKPOINT_PX: 1152,
  MEDIUM_ITEMS_PER_ROW_COUNT: 6,
  MIN_BREAKPOINT_PX: 768,
  MIN_ITEMS_PER_ROW_COUNT: 2,
  SMALL_ITEMS_PER_ROW_COUNT: 4,
  XLARGE_BREAKPOINT_PX: 1920,
  XLARGE_ITEMS_PER_ROW_COUNT: 8,
} as const);

export default GridConstants;
